// extracted by mini-css-extract-plugin
export var christmasHolder = "weddingsAndEvents-module--christmasHolder--3e1f0";
export var weddingsAndEventsHolder = "weddingsAndEvents-module--weddingsAndEventsHolder--14b54";
export var weddingsLayout = "weddingsAndEvents-module--weddingsLayout--8fae0";